import { AnimatePresence, motion } from "framer-motion";
import { Play, Pause, Volume2, X, Music2 } from "lucide-react";
import { useAudio } from "@/context/AudioContext";

const fmt = (s) => {
  if (!s || isNaN(s)) return "0:00";
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60).toString().padStart(2, "0");
  return `${m}:${sec}`;
};

export const AudioBar = () => {
  const { open, setOpen, playing, toggle, current, duration, seek, volume, setVolume } = useAudio();
  const pct = duration ? (current / duration) * 100 : 0;

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 inset-x-0 z-[55] bg-brand-forestDeep/97 backdrop-blur-md border-t border-brand-goldLight/20"
          data-testid="audio-bar"
        >
          <div className="max-w-7xl mx-auto px-5 lg:px-10 py-3 flex items-center gap-4">
            <button data-testid="audiobar-toggle" onClick={toggle} className="grid place-items-center w-11 h-11 rounded-full bg-brand-goldLight text-brand-forestDeep shrink-0 hover:scale-105 transition-transform" aria-label="Speel of pauzeer">
              {playing ? <Pause size={18} /> : <Play size={18} className="ml-0.5" />}
            </button>

            <div className="hidden sm:flex items-center gap-2 text-brand-cream shrink-0">
              <Music2 size={16} className="text-brand-goldLight" />
              <span className="font-display text-lg">Ons lied</span>
            </div>

            <span className="text-brand-cream/70 text-xs font-body tabular-nums shrink-0 w-9 text-right">{fmt(current)}</span>
            <div
              className="flex-1 h-1.5 rounded-full bg-brand-cream/15 cursor-pointer overflow-hidden"
              onClick={(e) => {
                const r = e.currentTarget.getBoundingClientRect();
                seek(((e.clientX - r.left) / r.width) * duration);
              }}
            >
              <div className="h-full bg-brand-goldLight rounded-full" style={{ width: `${pct}%` }} />
            </div>
            <span className="text-brand-cream/70 text-xs font-body tabular-nums shrink-0 w-9">{fmt(duration)}</span>

            <div className="hidden md:flex items-center gap-2 shrink-0 w-28">
              <Volume2 size={16} className="text-brand-cream/70" />
              <input
                data-testid="audiobar-volume"
                type="range" min="0" max="1" step="0.01" value={volume}
                onChange={(e) => setVolume(parseFloat(e.target.value))}
                className="w-full accent-brand-goldLight"
              />
            </div>

            <button data-testid="audiobar-close" onClick={() => setOpen(false)} className="text-brand-cream/60 hover:text-brand-cream shrink-0" aria-label="Sluit speler">
              <X size={20} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
